import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'pcs-dropdown-item',
  template: '<ng-content></ng-content>',
  styleUrls: ['./dropdown-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownItemComponent {
  @Input() divider = false;
  @Input() active = false;
  @Input() disabled = false;

  @Output() selected = new EventEmitter();

  @HostBinding('class.dropdown-item')
  private readonly rootClasses = true;

  @HostBinding('class.dd-divider')
  private get hasDivider() {
    return this.divider;
  }

  @HostBinding('class.active')
  private get isActive() {
    return this.active;
  }

  @HostBinding('class.disabled')
  private get isDisabled() {
    return this.disabled;
  }

  @HostListener('click', ['$event'])
  onClick(event) {
    if (!this.disabled) {
      this.selected.emit(event);
    }
  }
}
